import React from 'react';

import MedicalOrders from './MedicalOrders';

const MedicalSummary = () => <MedicalOrders mineOnly />;

export default MedicalSummary;
